import api, { cardeal } from './api';

export class MemoriaCalculoParticipanteService {
  getMemoriaCalculoBeneficioParticipante = (matricula, plano) => {
    return cardeal.get('ObterMemoriaCalculoBeneficioParticipante', {
      params: {
        matricula,
        plano,
      },
    });
  };

  gerarMemoriaCalculo = (matricula, plano, nome, token) => {
    return api.get('GerarMemoriaCalculo', {
      params: {
        matricula,
        plano,
        nome,
        token,
      },
      responseType: 'arraybuffer',
    });
  };

  gerarResumoTransformacaoBeneficio = (user, dadosTransformacao) => {
    return api.get('GerarResumoTransformacaoBeneficio', {
      params: {
        matricula: user.matricula,
        nome: user.dadosPessoais.nome,
        token: user.token,
        beneficio: dadosTransformacao.tipoBeneficio,
        protocolo: dadosTransformacao.protocolo,
        forma: dadosTransformacao.formaRecebimento,
        dtSol: dadosTransformacao.dataSolicitacao,
        percentual: dadosTransformacao.percentualRecebimento,
        qtdFamiliar: dadosTransformacao.pessoasGrupoFamiliar,
        tipo: dadosTransformacao.tipoBeneficio,
      },
      responseType: 'arraybuffer',
    });
  };
}
